window.sizeConversionMizuno = {
  "EU 35": { "US M": "4",   "US W": "5.5",   "UK": "3", "CM": "22" },
  "EU 36": { "US M": "4.5",   "US W": "6",   "UK": "3.5", "CM": "22.5" },
  "EU 36.5": { "US M": "5", "US W": "6.5", "UK": "4",   "CM": "23" },
  "EU 37": { "US M": "5.5", "US W": "7",   "UK": "4.5", "CM": "23.5" },
  "EU 38": { "US M": "6",   "US W": "7.5", "UK": "5",   "CM": "24" },
  "EU 38.5": { "US M": "6.5", "US W": "8",   "UK": "5.5", "CM": "24.5" },
  "EU 39": { "US M": "7",   "US W": "8.5", "UK": "6",   "CM": "25" },
  "EU 40": { "US M": "7.5", "US W": "9",   "UK": "6.5", "CM": "25.5" },
  "EU 40.5": { "US M": "8", "US W": "9.5",     "UK": "7",   "CM": "26" },
  "EU 41": { "US M": "8.5", "US W": "10", "UK": "7.5", "CM": "26.5" },
  "EU 42": { "US M": "9",   "US W": "10.5",  "UK": "8",   "CM": "27" },
  "EU 42.5": { "US M": "9.5", "US W": "11", "UK": "8.5", "CM": "27.5" },
  "EU 43": { "US M": "10",   "US W": "11.5",     "UK": "9",   "CM": "28" },
  "EU 44": { "US M": "10.5", "US W": "12",  "UK": "9.5", "CM": "28.5" },
  "EU 44.5": { "US M": "11", "US W": "12.5",     "UK": "10",  "CM": "29" },
  "EU 45": { "US M": "11.5", "US W": "13",     "UK": "10.5", "CM": "29.5" },
  "EU 46": { "US M": "12",  "US W": "13.5",     "UK": "11",  "CM": "30" },
  "EU 46.5": { "US M": "12.5", "US W": "14",   "UK": "11.5", "CM": "30.5" },
  "EU 47": { "US M": "13",  "US W": "14.5",     "UK": "12",  "CM": "31" },
  "EU 48": { "US M": "13.5",  "US W": "15",   "UK": "12.5",  "CM": "31.5" },
  "EU 48.5": { "US M": "14",  "US W": "15.5",   "UK": "13",  "CM": "32" },
  "EU 50": { "US M": "15",  "US W": "16.5",     "UK": "14",  "CM": "33" }
};